import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.scout-report-point-form', () => {
  void import('./internal/scout-report-point-form').then(({ default: Component }) => Component());
});
